import styled from 'styled-components'
import { SMALL_BREAKPOINT } from '../../../style'

export const PageHeader = styled.div`
  display: flex;
  margin-bottom: 1.5rem;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    padding-top: 1.5rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardIntegrations/BrandDashboardIntegrations.style.tsx